import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import supremegCrt from './assets/images/supremecourt.jpeg';

const stats = [
  { value: '30+', label: 'Years of Trial Expertise' },
  { value: '800+', label: 'Resolved matters across Pakistan' },
  { value: '3', label: 'Languages (English / Urdu / Sindhi)' },
];

const practiceAreas = [
  {
    title: 'Civil & Commercial Litigation',
    copy:
      'Representation before District Courts, High Courts, and tribunals with a focus on complex civil and contractual disputes.',
  },
  {
    title: 'Succession, Probate & Inheritance',
    copy:
      'Preparation of succession certificates, probate petitions, and dispute resolution to safeguard generational wealth.',
  },
  {
    title: 'Family Law & Personal Matters',
    copy:
      'Compassionate assistance for maintenance, divorce, khula, child custody, and dowry recovery with utmost confidentiality.',
  },
  {
    title: 'Banking & Rent Cases',
    copy:
      'Strategic defence and prosecution for financial institutions, landlords, and tenants to protect commercial interests.',
  },
  {
    title: 'Contracts & Compliance',
    copy:
      'Drafting, vetting, and negotiation of agreements plus compliance programs tailored for SMEs and large corporates.',
  },
  {
    title: 'Corporate Advisory',
    copy:
      'Retainer-based advisory, governance reviews, and risk mitigation plans for boards, startups, and overseas partners.',
  },
];

const engagementSteps = [
  { title: '01. Listening Session', copy: 'We map facts, urgency, and desired outcomes during an in-depth discovery call.' },
  { title: '02. Strategy Memo', copy: 'You receive a practical course of action with timelines, risks, and documentation needs.' },
  { title: '03. Legal Execution', copy: 'Filings, appearances, negotiations, and reporting handled end-to-end by our core team.' },
];

function Home() {
  return (
    <main className="home">
      <section className="hero">
        <div className="hero-text">
          <p className="eyebrow">Full-service Pakistani law firm</p>
          <h2>Clarity, discretion, and decisive action when the stakes are highest.</h2>
          <p>
            Irfan Haroon &amp; Associates blends three decades of courtroom experience with modern, proactive advisory for
            families, entrepreneurs, and international partners operating in Pakistan.
          </p>
          <div className="hero-actions">
            <a href="https://wa.me/923343161042" className="button" target="_blank" rel="noopener noreferrer">
              Schedule a Consultation
            </a>
            <div className="secondary-link">
              <span>Call</span>
              <a href="tel:+923343161041">+92 334 316 1041</a>
              <span>/</span>
              <a href="tel:+923343161042">+92 334 316 1042</a>
            </div>
          </div>
          <p className="virtual-consult">
            Book a video consultation and get trusted Pakistan counsel from anywhere. Available via Zoom, Google Meet,
            and WhatsApp.
          </p>
          <div className="stats-row">
            {stats.map(({ value, label }) => (
              <div key={label} className="stat">
                <span className="stat-value">{value}</span>
                <span className="stat-label">{label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-visual">
          <img src={supremegCrt} alt="Supreme Court of Pakistan" />
          <div className="hero-card">
            <p>Active before the Supreme Court and High Courts of Pakistan.</p>
            <span>Karachi · Islamabad · Hyderabad</span>
          </div>
        </div>
      </section>

      <section className="confidence-strip">
        <div>
          <p className="eyebrow">Trusted by</p>
          <h3>Export Processing Zone Authority · Joe&apos;s Fashion · Oslo Contracts · Deokjae Constructions</h3>
          <p>Alongside distinguished families, industrial groups, and overseas Pakistanis.</p>
        </div>
      </section>

      <section className="card-grid">
        <div className="section-head">
          <p className="eyebrow">Practice Areas</p>
          <h2>Precision-built strategies for every matter.</h2>
          <p>
            Whether you require representation in civil courts, discreet family counsel, or a standing advisor for your
            corporation, our blended litigation and consulting approach keeps you protected.
          </p>
        </div>
        <div className="grid">
          {practiceAreas.map(({ title, copy }) => (
            <article key={title} className="card">
              <h3>{title}</h3>
              <p>{copy}</p>
              <span className="card-accent">Tailored strategy · Transparent reporting</span>
            </article>
          ))}
        </div>
        <Link to="/services" className="button center-button">
          Explore complete service roster
        </Link>
      </section>

      <section className="dual-section">
        <div className="panel">
          <p className="eyebrow">Why clients rely on us</p>
          <h2>Responsive, discreet, and relentlessly prepared.</h2>
          <ul>
            <li>Direct access to senior counsel with zero outsourcing of critical hearings.</li>
            <li>Case updates, filings, and evidence tracking delivered through structured reports.</li>
            <li>Multilingual team for cross-border work and negotiations with global partners.</li>
            <li>Layered fee structures to support both urgent interventions and long-term retainers.</li>
          </ul>
        </div>
        <div className="panel steps">
          <p className="eyebrow">Engagement roadmap</p>
          {engagementSteps.map(({ title, copy }) => (
            <div key={title} className="step">
              <h3>{title}</h3>
              <p>{copy}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="contact-cta">
        <p className="eyebrow">Prefer a quick answer?</p>
        <h2>Share your documentation securely and receive a response within 24 hours.</h2>
        <p>
          Email concise details to <strong>irfanharoon@irfanharoonassociates.com</strong>, <strong>vatao4@hotmail.com</strong>,
          or <strong>vatao4@gmail.com</strong> or tap WhatsApp for live coordination. Every inquiry is handled directly by
          Irfan Haroon for confidentiality.
        </p>
        <div className="cta-actions">
          <Link to="/contact" className="button">
            Book a formal meeting
          </Link>
          <a className="button" href="https://wa.me/923343161042" target="_blank" rel="noopener noreferrer">
            Message on WhatsApp
          </a>
        </div>
      </section>
    </main>
  );
}

export default Home;
